export default {
    namespaced: true,
    state: {
        stateList: ["AK", "AL", "AR", "AZ", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME", "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ", "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"],
        lenUnit: ["cm", "inch"],
        weightUnit: ["g", "lbs"],
        currency: ['USD', 'CNY', 'CAD', 'EUR', 'GPB', 'AUD', 'JPY'],
        countryList: ["US", "ES", "DE","JP"],
        marketplaceId : {
            'CA' : 'A2EUQ1WTGCTBG2',
            'MX' : 'A1AM78C64UM0Y8',
            'US' : 'ATVPDKIKX0DER',
            'BR' : 'A2Q3Y263D00KWC',
            'DE' : 'A1PA6795UKMFR9',
            'ES' : 'A1RKKUPIHCS9HS',
            'FR' : 'A13V1IB3VIYZZH',
            'IT' : 'APJ6JRA9NG5V4',
            'UK' : 'A1F83G8C2ARO7P',
            'GB' : 'A1F83G8C2ARO7P',
            'IN' : 'A21TJRUUN4KGV',
            'AU' : 'A39IBJ37TRP1C6',
            'JP' : 'A1VC38T7YXB528',
            'CN' : 'AAHKV2X7AFYLW',
            'AE' : 'A2VIGQ35RCS4UG',
            'NL' : 'A1805IZSGTT6HS',
            'SE' : 'A2NODRKZP88ZB9',
            'PL' : 'A1C3SOZRARQ6R3',
            'BE' : 'AMEN7PMS3EDWL'
        },
        salesunit:[
            {value:'Bag',name:'Bag-袋、包'},
            {value:'Bar',name:'Bar-条'},
            {value:'Bottle',name:'Bottle-瓶'},
            {value:'Box',name:'Box-盒'},
            {value:'Bundle',name:'Bundle-捆'},
            {value:'Carton',name:'Carton-箱'},
            {value:'Dozen',name:'Dozen-打'},
            {value:'Ea',name:'Ea-个'},
            {value:'Pair',name:'Pair-副'},
            {value:'Pcs',name:'Pcs-件'},
            {value:'Piece',name:'Piece-只'},
            {value:'Set',name:'Set-台、套'},
            {value:'Unit',name:'Unit-辆'},
        ],
        productsSizeList:[
            {lable:'',color:''},
            {label:'Small standard-size',color:'tag-green tagSize'},
            {label:'Large standard-size',color:'tag-deepgreen tagSize'},
            {label:'Small oversize',color:'tag-blue tagSize'},
            {label:'Medium oversize',color:'tag-purple tagSize'},
            {label:'Large oversize',color:'tag-orange tagSize'},
            {label:'Special oversize',color:'tag-red tagSize'},
        ]
    },
    getters: {
        getStateList(state, getters) {
            return state.stateList;
        },
        getCountryList(state, getters) {
            return state.countryList;
        },
        getLenUnitList(state, getters) {
            return state.lenUnit;
        },
        getWeightUnitList(state, getters) {
            return state.weightUnit;
        },
        getCurrencyList(state, getters) {
            return state.currency;
        },
        getMarketplaceId(state, getters) {
            return state.marketplaceId;
        },
        getProductsSizeList(state, getters) {
            return state.productsSizeList;
        },
    },
    mutations: {
    },
    actions: {
    }
};
